import css from 'styled-jsx/css';

const styles = css.global`#banco-auto-25-banner {
  background: #181818;
}

#banco-auto-25-banner.stacked-banner {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: start;
  position: relative;
}

#banco-auto-25-banner .bg-image-wrapper {
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
}

#banco-auto-25-banner .bg-image-wrapper picture {
  display: flex;
  width: 100%;
  height: 100%;
}

#banco-auto-25-banner .bg-image-wrapper picture img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
#banco-auto-25-banner .fade-banner {
  opacity: 0.25;
  background: var(--Red-Red-Boston-01, #C00);
  position: absolute;
  width: 100%;
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
}
#banco-auto-25-banner .fade-banner-gradiente {
  background: linear-gradient(90deg, #900 0%, rgba(153, 0, 0, 0.73) 10.94%, rgba(153, 0, 0, 0.00) 56.77%);
  width: 100%;
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
  position: absolute;
}

#banco-auto-25-banner .santander-symbol {
  background-image: url(assets/c2c/banners/santander-symbol.svg);
  width: 100%;
  height: calc(100vh - 300px);
  max-height: 454px;
  min-height: 270px;
  position: absolute;
  left: -90px;
  background-repeat: no-repeat;
  background-size: contain;
}

#banco-auto-25-banner .text-box-position {
  margin-top: -200px;
  position: relative;
}

#banco-auto-25-banner .text-box {
  background: #990000;
  width: 100%;
  max-width: 849px;
  padding: 24px 16px 40px 16px;
  border-radius: 4px;
  box-sizing: border-box;
}

#banco-auto-25-banner .text-box .main-text {
  font-family: 'SantanderHeadline';
  font-size: 40px;
  font-weight: 400;
  line-height: 60px;
  text-align: left;
  margin-bottom: 8px;
  margin-bottom: 8px;
  color: #fff;
}

#banco-auto-25-banner .text-box .alt-text {
  font-family: 'SantanderText';
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
  text-align: left;
  margin-bottom: 24px;
  color: #fff;
  max-width: 500px;
}

#banco-auto-25-banner .text-box .btn-simulate {
  box-sizing: border-box;
  height: 48px;
  width: 200px;
}


@media (min-width: 992px) {
  #banco-auto-25-banner .text-box {
    padding: 24px 47px;
  }

  #banco-auto-25-banner .santander-symbol { 
    left: 0;
    width: 537px;
    height: calc(100vh - 180px);
    max-height: 436px;
    min-height: 300px;
  }

  #banco-auto-25-banner .bg-image-wrapper,
  #banco-auto-25-banner .fade-banner,
  #banco-auto-25-banner .fade-banner-gradiente {
    height: calc(100vh - 180px);
    max-height: 436px;
    min-height: 300px;
  }
}
/* @media (min-width: 1200px) {
  #banco-auto-25-banner .bg-image-wrapper picture img {
    object-position: 0 40%;
  } 
}

@media (min-width: 1600px) {
  #banco-auto-25-banner .bg-image-wrapper picture img {
    object-position: 0 40%;
  } 
}

@media (min-width: 1900px) {
  #banco-auto-25-banner .bg-image-wrapper picture img {
    object-position: 0 39%;
  } 
} */`;

export default styles;